module.exports = __webpack_public_path__ + "assets/images/smoke_g.338c9a60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/smoke_g.png
// module id = 765
// module chunks = 1